<label [class.checked]="input.checked">
  <input type="checkbox" #input />
  <div class="slider">
    <div class="thumb"></div>
  </div>
  <div class="text">
    <ng-content></ng-content>
  </div>
</label>
